import { Transforms, Text, Editor, Path } from 'slate';
import { nanoid } from 'nanoid';

// Only a node that still carries the id elsewhere makes it a duplicate. A node seen at a new path
// may just have moved (drag and drop, wrapping in a layout), and it keeps its id.
function isUsedElsewhere(editor, id, path) {

  function hasSameId(node) {
    return Text.isText(node) === false && typeof node.properties === 'object' && node.properties !== null && node.properties.id === id;
  }

  for (const [, otherPath] of Editor.nodes(editor, { at: [], match: hasSameId })) {
    if (Path.equals(otherPath, path) === false) {
      return true;
    }
  }

  return false;

}

function withUniqueId(editor) {

  const { normalizeNode } = editor;

  const idMap = new Map();

  function needsNewId(id, path) {

    if (typeof id !== 'string') {
      return true;
    }

    if (idMap.has(id) === false || Path.equals(idMap.get(id), path) === true) {
      return false;
    }

    return isUsedElsewhere(editor, id, path);

  }

  editor.normalizeNode = function normalizeNodeOverride(entry) {

    const [node, path] = entry;
    if (Text.isText(node) === false && Editor.isEditor(node) === false) {
      let properties = { ...node.properties } || {};

      if (needsNewId(properties.id, path) === true) {
        properties.id = nanoid();
        Transforms.setNodes(editor, { properties }, { at: path });
      }

      // Ensure the ID is registered in the map
      idMap.set(properties.id, path);
    }

    normalizeNode(entry);
  };

  return editor;
};

export default withUniqueId;